<template>
	<div class="clearfix choice">
		<div class="btn-add-pic" v-show="hasImage">
	        <input type="file" class="hidden" :id="'upload-img-poll-' + (index + 1)"  @change="onFileChange">
	        <label :for="'upload-img-poll-' + (index + 1)"><i class="fa fa-plus-circle dash-color-skin-light-30 cursor-pointer"></i></label>
		</div>
		<div class="setup-margin-input" :class="{ 'setup-no-img' : !hasImage , 'setup-width-input' : hasImage}">
			<input type="text" v-validate="'required'" :class="{ 'input-error' : errors.has('choice') }" name="choice" class="dash-border-color-skin input-poll-choice" :placeholder="labels[nowLang].choicePlaceHolder" v-model="choiceObj.text">
      <div class="trash-poll dash-color-skin-light-30">
        <i class="fa fa-trash" aria-hidden="true" v-on:click="delChoice(index)"></i>
      </div>
      <div class="text-error" v-show="errors.has('choice')">{{errors.first('choice')}}</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'choice-poll',
  props: [ 'choiceObj', 'index', 'delChoice', 'hasImage', 'nowLang' ],
  data () {
    return {
      labels: {
        en: {
          choicePlaceHolder: 'Input choice'
        },
        th: {
          choicePlaceHolder: 'กรอกตัวเลือก'
        }
      }
    }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
    },
    createImage (file) {
      this.choiceObj.image = '~static/poll/penguin.png'
      this.choiceObj.number = 0
      this.choiceObj.selected = 'N'
    }
  }
}
</script>


// WEBPACK FOOTER //
// choicePoll.vue?bcc9fa6c